import { useDispatch, useSelector } from 'react-redux';
import { useEffectOnce } from 'usehooks-ts';

import { useRouteParam } from '@hooks/params';

import { selectCancerQuotePaymentPage } from './selector';
import {
  cancerQuoteFetch,
  CancerQuoteFetchPayload,
  billingFetch,
  BillingFetchPayload,
} from './action';

export const useCancerQuoteFetch = () => {
  const orderNumber = useRouteParam('orderNumber') as string;
  const dispatch = useDispatch();
  const { cancerQuote } = useSelector(selectCancerQuotePaymentPage);
  useEffectOnce(() => {
    const payload: CancerQuoteFetchPayload = { orderNumber };
    dispatch(cancerQuoteFetch(payload));
  });
  return cancerQuote;
};

export const useBillingFetch = () => {
  const dispatch = useDispatch();
  const billingId = Number(useRouteParam('billingId'));
  const { billing } = useSelector(selectCancerQuotePaymentPage);
  useEffectOnce(() => {
    const payload: BillingFetchPayload = { id: billingId };
    dispatch(billingFetch(payload));
  });
  return billing;
};
